import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Home from "../views/Home.vue";
import Home2 from "../views/Home2.vue";
import Login from "../views/Login.vue";
import store from '@/store';

const routes = [
  {
    path: "/",
    name: "/",
  //redirect: "/dashboard-default",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      logged: true,
    }
  },
  {
    path: "/home-2",
    name: "Home 2",
    component: Home2,
    meta: {
      logged: true,
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

//router.beforeEach(function(to, from) {
router.beforeEach(function(to) {  
  // ...
  // explicitly return false to cancel the navigation
  //console.log(from);
  //console.log(to.meta);

  if(to.meta && to.meta.logged == true && !store.getters['user/token'])
    return '/login';

  if(to.meta && to.meta.right) {

    if(!store.getters['user/token']) return '/login';

    var can = store.getters['user/rights'].indexOf(to.meta.right) != -1;

    if(can) return true;
    else return false;
  }

  return true;
  //return false
});

export default router;
